import { useAuth } from '../hooks/useAuth'

export function Account() {
  const { user, logout } = useAuth()

  return (
    <div className="page account">
      <header className="header">
        <h1>Account</h1>
      </header>

      <div className="account-section">
        <div className="account-card">
          <h3>Profile</h3>
          <div className="field">
            <label>Email</label>
            <p>{user?.email}</p>
          </div>
          <div className="field">
            <label>Name</label>
            <p>{user?.name || 'Not set'}</p>
          </div>
          <div className="field">
            <label>Trade</label>
            <p>{user?.trade || 'Not set'}</p>
          </div>
        </div>

        <div className="account-card">
          <h3>Verification</h3>
          <div className="field">
            <label>CSCS Card</label>
            <p className={`status ${user?.cscs_status}`}>
              {user?.cscs_status === 'approved' ? '✓ Verified' :
               user?.cscs_status === 'pending' ? '⏳ Under review' :
               user?.cscs_status === 'rejected' ? '✗ Rejected — re-upload needed' :
               'Not uploaded'}
            </p>
          </div>
          {user?.cscs_status !== 'approved' && (
            <a href="/verify" className="btn-secondary">
              Upload CSCS card
            </a>
          )}
        </div>

        <div className="account-card">
          <h3>Subscription</h3>
          <div className="field">
            <label>Tier</label>
            <p className="tier">{user?.subscription_tier || 'basic'}</p>
          </div>
        </div>

        <button className="btn-danger" onClick={logout}>
          Log out
        </button>
      </div>
    </div>
  )
}
